/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Col, Row } from 'antd';
import Logo from 'components/Logo';
import { LogoTextStyled } from 'containers/Sidebar/styled';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE,
} from '../../constants/ThemeSetting';

const SidebarLogo = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { width, themeType } = useSelector(({ settings }) => settings);
  let navStyle = useSelector(({ settings }) => settings.navStyle);
  if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
    navStyle = NAV_STYLE_DRAWER;
  }
  return (
    <div className='gx-layout-sider-header'>
      {navStyle === NAV_STYLE_FIXED || navStyle === NAV_STYLE_MINI_SIDEBAR ? (
        <div className='gx-linebar'>
          <button
            className='gx-header-icon-btn-wrapper'
            type='button'
            onClick={() => {
              setSidebarCollapsed(!sidebarCollapsed);
            }}>
            <i
              className={`gx-icon-btn icon icon-${!sidebarCollapsed ? 'menu-unfold' : 'menu-fold'} ${
                themeType !== THEME_TYPE_LITE ? 'gx-text-white' : ''
              }`}
            />
          </button>
        </div>
      ) : null}

      <Link to='/' className='gx-site-logo'>
        {navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR && width >= TAB_SIZE ? (
          <Logo />
        ) : (
          <Row align='middle' className='gx-m-0'>
            <Col>
              <Logo />
            </Col>
            <Col>
              <LogoTextStyled>NotarizeMe</LogoTextStyled>
            </Col>
          </Row>
        )}
      </Link>
    </div>
  );
};

export default SidebarLogo;
